export enum ObjectModelPermissionCapabilityType {
  Enable = 1,
  Edit = 2,
  // Change User also uses the ConnectOrSever capability type
  ConnectOrSever = 3,
}